export enum SubmissionState {
    SUBMITTING = "submitting",
    NOT_SUBMITTING = "not-submitting",
    SUCCESSFULLY_SUBMITTED = "successfully-submitted"
}